module.exports = __webpack_public_path__ + "static/media/sel_13_264.e1c801c6.mp4";